"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverDefaultProps = exports.PopoverControllerDefaultProps = exports.POPPER_JS_REVERSE_POSITION_MAPPER = exports.POPPER_JS_POSITION_MAPPER = exports.POPOVER_BODY_RADIUS = exports.MENU_CONTENT_ROLE = exports.MAX_WIDTH_SMALL_VIEWPORT = exports.MAX_WIDTH_LARGE_VIEWPORT = exports.MAX_HEIGHT_SMALL_VIEWPORT = exports.MAX_HEIGHT_LARGE_VIEWPORT = exports.CONTENT_PADDING = exports.ARROW_WIDTH = exports.ARROW_HORIZONTAL_OFFSET = exports.ARROW_HEIGHT = exports.ANIMATION_SLIDE_AMOUNT = exports.ANIMATION_DURATION = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interfaces = require("./interfaces");

var _POPPER_JS_POSITION_M;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PopoverControllerDefaultProps = {
  position: _interfaces.PopoverPosition.BottomLeading,
  shouldFocusOnOpen: false,
  shouldCloseOnFocusLeave: true,
  shouldOverflow: true
};
exports.PopoverControllerDefaultProps = PopoverControllerDefaultProps;
var defaultTriggerButtonProps = {};

var PopoverDefaultProps = _objectSpread(_objectSpread({}, PopoverControllerDefaultProps), {}, {
  triggerButtonProps: defaultTriggerButtonProps
});

exports.PopoverDefaultProps = PopoverDefaultProps;
var MENU_CONTENT_ROLE = 'menu';
exports.MENU_CONTENT_ROLE = MENU_CONTENT_ROLE;
var POPOVER_BODY_RADIUS = 'R300';
exports.POPOVER_BODY_RADIUS = POPOVER_BODY_RADIUS;
var ARROW_HEIGHT = 8;
exports.ARROW_HEIGHT = ARROW_HEIGHT;
var ARROW_WIDTH = ARROW_HEIGHT * 2;
exports.ARROW_WIDTH = ARROW_WIDTH;
var ARROW_HORIZONTAL_OFFSET = 8;
exports.ARROW_HORIZONTAL_OFFSET = ARROW_HORIZONTAL_OFFSET;
var ANIMATION_DURATION = 200;
exports.ANIMATION_DURATION = ANIMATION_DURATION;
var ANIMATION_SLIDE_AMOUNT = 16;
exports.ANIMATION_SLIDE_AMOUNT = ANIMATION_SLIDE_AMOUNT;
var CONTENT_PADDING = 'S300';
exports.CONTENT_PADDING = CONTENT_PADDING;
var MAX_WIDTH_LARGE_VIEWPORT = '40vw';
exports.MAX_WIDTH_LARGE_VIEWPORT = MAX_WIDTH_LARGE_VIEWPORT;
var MAX_WIDTH_SMALL_VIEWPORT = 'calc(100vw - 32px)';
exports.MAX_WIDTH_SMALL_VIEWPORT = MAX_WIDTH_SMALL_VIEWPORT;
var MAX_HEIGHT_LARGE_VIEWPORT = '80vh';
exports.MAX_HEIGHT_LARGE_VIEWPORT = MAX_HEIGHT_LARGE_VIEWPORT;
var MAX_HEIGHT_SMALL_VIEWPORT = '60vh';
exports.MAX_HEIGHT_SMALL_VIEWPORT = MAX_HEIGHT_SMALL_VIEWPORT;
var POPPER_JS_POSITION_MAPPER = (_POPPER_JS_POSITION_M = {}, (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.TopLeading, 'top-start'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.TopCenter, 'top'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.TopTrailing, 'top-end'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.BottomLeading, 'bottom-start'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.BottomCenter, 'bottom'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.BottomTrailing, 'bottom-end'), _POPPER_JS_POSITION_M);
exports.POPPER_JS_POSITION_MAPPER = POPPER_JS_POSITION_MAPPER;
var POPPER_JS_REVERSE_POSITION_MAPPER = Object.entries(POPPER_JS_POSITION_MAPPER).reduce(function (acc, _ref) {
  var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  acc[value] = key;
  return acc;
}, {});
exports.POPPER_JS_REVERSE_POSITION_MAPPER = POPPER_JS_REVERSE_POSITION_MAPPER;